/* Add-to-cart upsell popup (see snippets/atc-upsell.liquid).
 *
 * Catches the product form's submit in the capture phase, before
 * product-block-buy-buttons.js sees it, and shows the offer. Whatever the shopper picks,
 * the form is then re-submitted untouched, so the theme's own add (charm staging, bundles,
 * drawer open) runs exactly as it does without the popup. A ticked offer is added to the
 * cart first, with its discount code applied, so the drawer that the theme opens
 * already shows both. */
(() => {
  const dataEl = document.getElementById('atc-upsell-data');
  const dialog = document.getElementById('atc-upsell');
  if (!dataEl || !dialog) return;

  const offer = JSON.parse(dataEl.textContent);
  if (!offer.variants.length) return;

  const select = dialog.querySelector('[data-upsell-variant]');
  const priceEl = dialog.querySelector('[data-upsell-price]');
  const check = dialog.querySelector('[data-upsell-check]');
  const addBtn = dialog.querySelector('[data-upsell-add]');
  let pendingForm = null;
  let passThrough = false;

  const money = (cents) => {
    const amount = cents / 100;
    return '$' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
  };

  const currentVariant = () =>
    offer.variants.find((v) => String(v.id) === (select ? select.value : '')) || offer.variants[0];

  const renderPrice = () => {
    const v = currentVariant();
    if (offer.percent > 0) {
      const sale = Math.round(v.price * (100 - offer.percent) / 100);
      priceEl.innerHTML = `<em>-${offer.percent}%</em><s>${money(v.price)}</s>${money(sale)}`;
    } else {
      priceEl.textContent = money(v.price);
    }
  };

  if (select) {
    select.innerHTML = offer.variants
      .map((v) => `<option value="${v.id}">${v.title.replace(/</g, '&lt;')}</option>`)
      .join('');
    select.addEventListener('change', () => { check.checked = true; renderPrice(); });
  }
  renderPrice();

  // Clicking anywhere on the offer card toggles it, except on the variant select.
  dialog.querySelector('[data-upsell-offer]').addEventListener('click', (e) => {
    if (e.target === check || e.target === select) return;
    check.checked = !check.checked;
  });

  // Setting `discount` replaces the cart's codes, so resend any already applied.
  const applyCode = async (code) => {
    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());
    const codes = (cart.discount_codes || []).map((d) => d.code).filter((c) => c && c.toUpperCase() !== code);
    await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: [...codes, code].join(',') }),
    });
  };

  const offerInCart = () =>
    (window.theme?.cartData?.items || []).some((item) => item.product_id === offer.productId);

  // Sets that require charms show their own prompt from the theme's submit handler.
  const charmsMissing = () => {
    if (!document.querySelector('.mpb[data-require-charms="true"]')) return false;
    const cikb = window.CIKB;
    return !(cikb && typeof cikb.getStagedBundles === 'function' && cikb.getStagedBundles().length);
  };

  const resubmit = () => {
    const form = pendingForm;
    pendingForm = null;
    if (dialog.open) dialog.close();
    if (!form) return;
    passThrough = true;
    form.requestSubmit();
    passThrough = false;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (passThrough || !form.matches('form[data-product-form]')) return;
    if (form.dataset.productHandle !== offer.triggerHandle) return;
    if (offerInCart() || charmsMissing()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    pendingForm = form;
    check.checked = false;
    addBtn.disabled = false;
    dialog.showModal();
  }, true);

  dialog.querySelectorAll('[data-upsell-skip]').forEach((btn) => btn.addEventListener('click', resubmit));
  // Esc and backdrop clicks count as "skip": the shopper still asked for the main product.
  dialog.addEventListener('cancel', (e) => { e.preventDefault(); resubmit(); });
  dialog.addEventListener('click', (e) => { if (e.target === dialog) resubmit(); });

  addBtn.addEventListener('click', async () => {
    if (!check.checked) { resubmit(); return; }
    addBtn.disabled = true;
    try {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: currentVariant().id, quantity: 1, properties: { _upsell: offer.name } }],
        }),
      });
      if (offer.code) await applyCode(offer.code);
    } catch (e) {
      // The add-on failing must never block the main product.
    }
    resubmit();
  });
})();
